import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UserListPageUI from './UserListPageUI.js'

class UserListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      userList: null,
      //
      createMode: false,
      updateMode: false,
      deleteMode: false,
      selectedCount: 0,
      selectedUser: null
    }
  }

  render() {
    return (
      <UserListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        userList={this.state.userList}
        selectedUser={this.state.selectedUser}
        // modes
        selectedCount={this.state.selectedCount}
        createMode={this.state.createMode}
        updateMode={this.state.updateMode}
        deleteMode={this.state.deleteMode}
        // events
        onRowClick={this.onRowClick}
        onRefreshClick={this.onRefreshClick}
        onCreateClick={this.onCreateClick}
        onUpdateClick={this.onUpdateClick}
        onDeleteClick={this.onDeleteClick}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getSuperUsers(context)
  }

  getSuperUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/superusers`,
      cacheKey: CacheKeys.SuperUsers(),
      callback: this.getSuperUsersCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getSuperUsersCallback = (response) => {
    this.setState({errorList: response.errorList, userList : response.userList})
  }

  onRowClick = event => {
    event.stopPropagation()
    let userId = event.currentTarget.getAttribute('data-row-id')
    let userList = this.state.userList
    userList
      .filter(user => user.userId !== userId)
      .forEach(user => {
        user.selected = false
      })
    userList
      .filter(user => user.userId === userId && !user.owner)
      .forEach(user => {
        user.selected = !Boolean(user.selected)
      })

    this.setState({
      userList : userList,
      selectedCount: userList.filter(user => user.selected).length
    })
  }

  onCreateClick = () => {
    this.setState({createMode: true})
  }

  onUpdateClick = () => {
    let selectedUser
    this.state.userList.filter(user => user.selected).forEach(user => {
      selectedUser = user
    })
    this.setState({updateMode: true, selectedUser: selectedUser})
  }

  onDeleteClick = () => {
    let selectedUser
    this.state.userList.filter(user => user.selected).forEach(user => {
      selectedUser = user
    })
    this.setState({deleteMode: true, selectedUser: selectedUser})
  }

  onCancelClick = () => {
    this.setState({createMode:false, updateMode:false, deleteMode: false, errorList: null})
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.SuperUsers())
    this.setState({
      userList: null,
      errorList: null,
      selectedCount: 0
    }, this.getSuperUsers(this.props.context)
    )
  }
}

export default UserListPageSF
